import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-back',
  imports: [TranslateModule],
  templateUrl: './back.component.html',
  styleUrl: './back.component.css',
})
export class BackComponent {
  private router = inject(Router);

  onBack() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      this.router.navigate(['/']);
    }
  }
}
